import React, { Fragment, useEffect, useState } from "react";
import { Box, SwipeableDrawer } from "@mui/material";
import Util from "../../../Util";
import { useTranslation } from "react-i18next";
import moment from "moment/moment";
import TagButton from "../../Dashbord/TagButton";
import {
  greenTagStyle,
  orangeTagStyle,
  redTagStyle,
} from "../../Dashbord/TagButtonStyle";
import { imageAddSchool, imageStudentList } from "../../CommonImage";
import ApiCalling from "../../../network/ApiCalling";
import Loader from "../../../components/common/Loader";
import { InvoiceStatus } from "../../../Enums";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Close from "../../../assets/Icon/close.png";

export default function InvoiceView({ show, onClose, invoiceId }) {
  console.log("invoice", invoiceId);
  const getLanguage = Util.getSelectedLanguage();
  const { t } = useTranslation();
  const [discount, setDiscount] = useState(false);
  const [invoiceDetail, setInvoiceDetail] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const StudentDetails = Util.isValidData(invoiceDetail) && [
    invoiceDetail?.Student,
  ];
  const isParent = Util.getParentMode();
  const school = Util.getSelectedSchool();
  const getAllInvoiceDetails = () => {
    setIsLoading(true);
    ApiCalling.apiCallBodyDataGet(`billing-invoice/${invoiceId}`)
      .then((res) => {
        setIsLoading(false);
        console.log(res.data);
        setInvoiceDetail(res.data);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };
  useEffect(() => {
    if (invoiceId > 0) {
      getAllInvoiceDetails();
    }
  }, [invoiceId]);
  useEffect(() => {
    if (Util.isValidData(invoiceDetail)) {
      if (
        Util.isValidData(invoiceDetail?.discount_amount) &&
        Util.isValidData(invoiceDetail?.discount_type)
      ) {
        setDiscount(true);
      } else {
        setDiscount(false);
      }
    }
  }, [invoiceDetail]);

  return (
    <div>
      {Util.isValidData(invoiceDetail) && (
        <SwipeableDrawer
          // hideBackdrop={true}
          anchor={getLanguage == "ar" ? "left" : "right"}
          open={show}
          onClose={() => {
            if (Util.isValidData(invoiceDetail)) {
              onClose();
            }
          }}
          onOpen={() => {}}
        >
          <div
            className="box-area"
            style={{ position: "relative", width: "100%", height: "100%" }}
          >
            <Box sx={{ width: "656px", padding: "20px" }} role="presentation">
              <div className="d-flex align-items-center justify-content-end">
                {/* <div className="text-start drawer-header">
                  {t("Invoice")}{" "}
                  {`(${Util.invoiceIdFormat(invoiceDetail?.id)})`}
                </div> */}
                <button
                  className="hidden-btn"
                  onClick={() => {
                    if (Util.isValidData(invoiceDetail)) {
                      onClose();
                    }
                  }}
                >
                  <img
                    src={Close}
                    className="svg-icon"
                    height={20}
                    width={20}
                  />
                </button>
              </div>
              {!isLoading ? (
                // <div className="body text-start mt-3">
                //   <div className="row text-start mt-2">
                //     <div className="mt-2 mb-2">
                //       <div className="basic-text text-secondary">{t("To")}</div>
                //       {Util.isValidArray(StudentDetails) &&
                //         StudentDetails.map((s, index) => {
                //           return (
                //             <span
                //               className="badge badge-students mt-2"
                //               key={index}
                //             >
                //               <img
                //                 className="rounded-circle mr-2"
                //                 style={{
                //                   width: "20px",
                //                   height: "20px",
                //                 }}
                //                 src={
                //                   s.photo
                //                     ? imageStudentList + s.photo
                //                     : "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png"
                //                 }
                //                 alt=""
                //               />
                //               {s.first_name + " " + s.last_name}
                //             </span>
                //           );
                //         })}
                //     </div>
                //     <div className="input-filed mt-2">
                //       <span className="basic-text text-secondary">
                //         {t("Invoice date")}
                //       </span>
                //       <div className="text-bold">
                //         {Util.isValidData(invoiceDetail?.date) &&
                //           moment(invoiceDetail?.date).format("DD/MM/YYYY")}
                //       </div>
                //     </div>
                //     <span className="basic-text text-secondary mt-2">
                //       {t("Fee type(s)")}
                //     </span>
                //     <div className="box-area">
                //       <div className="row px-4">
                //         {invoiceDetail?.types.map((f, index) => {
                //           return (
                //             <Fragment key={index}>
                //               <div className="col-9 mt-2">
                //                 <div className="text-bold">
                //                   {index + 1}. {f.Fee_Type}
                //                 </div>
                //               </div>
                //               <div className="col-3 mt-2">
                //                 <div className="text-bold">
                //                   {Util.amountFormat(f.amount)}
                //                 </div>
                //               </div>
                //             </Fragment>
                //           );
                //         })}
                //       </div>

                //       <hr style={{ backgroundColor: "#07112b" }} />
                //       <div className="row px-4 ">
                //         <div className="col-9 text-right">
                //           <div>{t("Sub Total")}</div>
                //         </div>
                //         <div className="col-3">
                //           <div className="text-bold">
                //             {Util.isValidData(invoiceDetail?.sub_total) &&
                //               Util.amountFormat(invoiceDetail?.sub_total)}
                //           </div>
                //         </div>
                //       </div>

                //       {discount && (
                //         <div className="row px-4">
                //           <div className="col-9 mt-2 text-right">
                //             <div className="text-success">{`Discount (${invoiceDetail?.discount_type})`}</div>
                //           </div>
                //           <div className="col-3 mt-2">
                //             <div className="text-bold">
                //               {Util.isValidData(
                //                 invoiceDetail?.discount_amount
                //               ) &&
                //                 Util.amountFormat(
                //                   invoiceDetail?.discount_amount
                //                 )}
                //             </div>
                //           </div>
                //         </div>
                //       )}
                //     </div>

                //     <div className="box-area">
                //       <div className="row px-4">
                //         <div className="col-9 mt-2 text-right">
                //           <div className="text-bold basic-large-text">
                //             {t("Total")}
                //           </div>
                //         </div>
                //         <div className="col-3 mt-2">
                //           <div className="text-bold basic-large-text">
                //             {Util.isValidData(invoiceDetail?.total) &&
                //               Util.amountFormat(invoiceDetail?.total)}
                //           </div>
                //         </div>
                //       </div>
                //     </div>
                //   </div>
                //   <div className="py-4">
                //     {invoiceDetail?.status == InvoiceStatus.PAID ? (
                //       <div className="alert alert-success text-center ">
                //         {t("Invoice is paid.")}
                //       </div>
                //     ) : invoiceDetail?.status == InvoiceStatus.PARTIAL_PAID ? (
                //       <div className="alert alert-warning text-center">
                //         {t("Invoice is Partially paid.")}
                //       </div>
                //     ) : (
                //       <div className="alert alert-danger text-center">
                //         {t("Invoice is not paid.")}
                //       </div>
                //     )}
                //   </div>
                //   {Util.isValidData(invoiceDetail) &&
                //     invoiceDetail?.payment_settled.length > 0 && (
                //       <div className="box-area">
                //         <span className="basic-text text-secondary">
                //           {t("Payment(s) against this invoice ")}
                //         </span>
                //         <table
                //           className="table"
                //           style={{
                //             border: "1px solid #e5e7eb",
                //             borderRadius: "12px",
                //           }}
                //         >
                //           <thead style={{ backgroundColor: "#e5e7eb" }}>
                //             <tr>
                //               <th>{t("Payer")}</th>
                //               <th>{t("Date")}</th>
                //               <th>{t("Total Amount")}</th>
                //               <th>{t("Amount Adjusted")}</th>
                //             </tr>
                //           </thead>
                //           {invoiceDetail?.payment_settled.length > 0 ? (
                //             <>
                //               <tbody>
                //                 {invoiceDetail?.payment_settled.map(
                //                   (In, index) => {
                //                     return (
                //                       <tr key={index}>
                //                         <td>
                //                           {" "}
                //                           {In.method}
                //                           <div className="small-text">
                //                             By {In.paid_by}
                //                           </div>
                //                         </td>
                //                         <td>
                //                           {moment(In.date).format("DD/MM/YYYY")}
                //                         </td>
                //                         <td>{Util.amountFormat(In.deposit)}</td>
                //                         <td>
                //                           {Util.amountFormat(
                //                             In.amount_adjusted
                //                           )}
                //                         </td>
                //                       </tr>
                //                     );
                //                   }
                //                 )}
                //                 <tr>
                //                   <td
                //                     colSpan={3}
                //                     className="text-bold text-right"
                //                   >
                //                     {t("Pending to pay")}
                //                   </td>
                //                   <td className="text-bold">
                //                     {Util.amountFormat(invoiceDetail?.due)}
                //                   </td>
                //                 </tr>
                //               </tbody>
                //             </>
                //           ) : (
                //             <tfoot>
                //               <tr>
                //                 <td colSpan={4}>{t("No record found")}</td>
                //               </tr>
                //             </tfoot>
                //           )}
                //         </table>
                //       </div>
                //     )}
                //   {!isParent && (
                //     <div className="mt-4">
                //       NOTE : {invoiceDetail?.payment_settled[0]?.note}
                //     </div>
                //   )}
                // </div>
                <>
                  <div className="d-flex justify-content-between">
                    <div className="col-md-6">
                      {invoiceDetail?.Student?.School?.logo ? (
                        <img
                          src={
                            imageAddSchool +
                            invoiceDetail?.Student?.School?.logo
                          }
                          alt="logo"
                          width={50}
                          height={50}
                        />
                      ) : (
                        <div style={{ width: "50px", height: "50px" }}></div>
                      )}
                      <div className="invoice-text-1 mt-3">
                        <div className="invoice-text-2">
                          {invoiceDetail?.Student?.School?.name}
                        </div>
                        {invoiceDetail?.Student?.School?.address1 && (
                          <div>
                            {invoiceDetail?.Student?.School?.address1 +
                              " " +
                              invoiceDetail?.Student?.School?.address2}
                          </div>
                        )}
                        <span>
                          Phone No:{" "}
                          {invoiceDetail?.Student?.School?.contact_phone}
                        </span>
                        <br></br>
                        <span>
                          Email: {invoiceDetail?.Student?.School?.contact_email}
                        </span>
                      </div>
                    </div>
                    <div className="col-md-6 d-flex justify-content-end">
                      <div className="text-end w-100">
                        <div className="invoice-title">Invoice</div>
                        <span className="invoice-text-3">
                          #{invoiceDetail?.id}
                        </span>
                        <div className="invoice-text-1">
                          <span>
                            INVOICE DATE:{" "}
                            {invoiceDetail?.date
                              ? moment(invoiceDetail?.date).format(
                                  Util.getMomentDateTimeFormat(
                                    school.date_format
                                  )
                                )
                              : "-"}
                          </span>
                          <br></br>
                          <span>
                            DUE DATE:{" "}
                            {invoiceDetail?.last_payment_date
                              ? moment
                                  .utc(invoiceDetail?.last_payment_date)
                                  .format(
                                    Util.getMomentDateTimeFormat(
                                      school.date_format
                                    )
                                  )
                              : "-"}
                          </span>
                          <br></br>
                          <br></br>
                          <span>
                            {invoiceDetail?.status == 0 ||
                            invoiceDetail?.status == 1
                              ? "AMOUNT DUE"
                              : invoiceDetail?.status == 3
                              ? "CANCELLED"
                              : "AMOUNT PAID"}
                          </span>
                        </div>
                        <div
                          className="amount-box"
                          style={{ marginLeft: "170px" }}
                        >
                          {invoiceDetail?.Student?.School?.currency}{" "}
                          {invoiceDetail?.status == 0 ||
                          invoiceDetail?.status == 1
                            ? invoiceDetail?.due
                            : invoiceDetail?.total}
                          {/* {invoiceDetail?.payment_settled.length > 0
                            ? invoiceDetail?.payment_settled[0]?.deposit -
                              invoiceDetail?.payment_settled[0]?.credit
                            : invoiceDetail?.total} */}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="d-flex justify-content-between mt-3">
                    <div className="col-md-6 invoice-text-1">
                      <span>BILLED TO</span>
                      <br></br>
                      <span className="invoice-text-4">
                        Parent Name:{" "}
                        {invoiceDetail?.Student?.primaryParent?.User
                          ?.firstName +
                          " " +
                          invoiceDetail?.Student?.primaryParent?.User?.lastName}
                      </span>
                      <br></br>
                      <span>
                        Email Address:{" "}
                        {invoiceDetail?.Student?.primaryParent?.User?.email}
                      </span>
                      <br></br>
                      <span>
                        Mobile No:{" "}
                        {invoiceDetail?.Student?.primaryParent?.User?.mobile}
                      </span>
                    </div>
                    <div className="col-md-6 invoice-text-1 text-end">
                      <span>STUDENT DETAILS</span>
                      <br></br>
                      <span className="invoice-text-4">
                        Student Name:{" "}
                        {invoiceDetail?.Student?.first_name +
                          " " +
                          invoiceDetail?.Student?.last_name}
                      </span>
                      <br></br>
                      <span>Term: {invoiceDetail?.Student?.Term?.title}</span>
                      <br></br>
                      <span>
                        Stage: {invoiceDetail?.Student?.grade?.Stage?.stage}
                      </span>
                      <br></br>
                      <span>Student ID: {invoiceDetail?.Student?.id}</span>
                    </div>
                  </div>

                  <div className="invoice-table mt-3">
                    <table className="table">
                      <thead>
                        <tr>
                          <td>#</td>
                          <td>TITLE/DESCRIPTION</td>
                          <td className="text-end">AMOUNT</td>
                        </tr>
                      </thead>
                      {invoiceDetail?.types?.length > 0 ? (
                        <tbody>
                          {invoiceDetail?.types?.map((item, index) => {
                            return (
                              <tr>
                                <td className="invoice-text-4">{index + 1}</td>
                                <td className="invoice-text-4">
                                  {item?.Fee_Type}
                                </td>
                                <td className="text-end">
                                  {invoiceDetail?.Student?.School?.currency}{" "}
                                  {item?.amount}
                                </td>
                              </tr>
                            );
                          })}
                          <tr>
                            <td className="invoice-text-4">
                              {invoiceDetail?.types?.length + 1}
                            </td>
                            <td className="invoice-text-4">
                              {invoiceDetail?.discount_type
                                ? invoiceDetail?.discount_type
                                : "DISCOUNT"}
                            </td>
                            <td className="text-end">
                              -{invoiceDetail?.Student?.School?.currency}{" "}
                              {invoiceDetail?.discount_amount}
                            </td>
                          </tr>
                        </tbody>
                      ) : (
                        <tfoot>
                          {" "}
                          <tr>
                            <td colSpan={4}>{t("No record found")}</td>{" "}
                          </tr>
                        </tfoot>
                      )}
                    </table>
                    <div className="d-flex justify-content-center">
                      <table className="table">
                        <tbody>
                          <tr>
                            <td colSpan={2} className="text-end invoice-text-4">
                              Subtotal
                            </td>
                            <td colSpan={2} className="text-end">
                              {invoiceDetail?.Student?.School?.currency}{" "}
                              {invoiceDetail?.sub_total -
                                (invoiceDetail?.discount_amount || 0)}
                            </td>
                          </tr>
                          {invoiceDetail?.taxDetails?.length > 0 && (
                            <>
                              {invoiceDetail?.taxDetails?.map((item, index) => {
                                return (
                                  <tr>
                                    <td
                                      colSpan={2}
                                      className="text-end invoice-text-4"
                                    >
                                      {item?.Tax?.tax_name}(
                                      {item?.Tax?.tax_percentage}%)
                                    </td>
                                    <td colSpan={2} className="text-end">
                                      {invoiceDetail?.Student?.School?.currency}{" "}
                                      {Math.floor(
                                        (item?.Tax?.tax_percentage / 100) *
                                          (invoiceDetail?.sub_total -
                                            (invoiceDetail?.discount_amount == 0
                                              ? 0
                                              : invoiceDetail?.discount_amount)) *
                                          100
                                      ) / 100}
                                    </td>
                                  </tr>
                                );
                              })}
                            </>
                          )}
                          <tr
                            style={{ border: "#6418C3", borderWidth: "10px" }}
                          >
                            <td colSpan={2} className="text-end invoice-text-4">
                              Total
                            </td>
                            <td colSpan={2} className="text-end">
                              {invoiceDetail?.Student?.School?.currency}{" "}
                              {/* {invoiceDetail?.payment_settled.length > 0
                                ? invoiceDetail?.payment_settled[0]?.deposit -
                                  invoiceDetail?.payment_settled[0]?.credit
                                : invoiceDetail?.total} */}
                              {invoiceDetail?.status == 0 ||
                              invoiceDetail?.status == 1
                                ? invoiceDetail?.due
                                : invoiceDetail?.total}
                            </td>
                          </tr>
                          <tr
                            style={{ border: "#6418C3", borderWidth: "10px" }}
                          >
                            <td colSpan={2} className="text-end invoice-text-5">
                              {invoiceDetail?.status == 0 ||
                              invoiceDetail?.status == 1
                                ? "AMOUNT DUE"
                                : invoiceDetail?.status == 3
                                ? "CANCELLED"
                                : "AMOUNT PAID"}
                            </td>
                            <td colSpan={2} className="text-end invoice-text-5">
                              {invoiceDetail?.Student?.School?.currency}{" "}
                              {/* {invoiceDetail?.payment_settled.length > 0
                                ? invoiceDetail?.payment_settled[0]?.deposit -
                                  invoiceDetail?.payment_settled[0]?.credit
                                : invoiceDetail?.total} */}
                              {invoiceDetail?.status == 0 ||
                              invoiceDetail?.status == 1
                                ? invoiceDetail?.due
                                : invoiceDetail?.total}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className="mt-5">
                      <div className="invoice-text-1">Thank You for the busniess!</div>

                      {invoiceDetail?.Student?.School?.bankInfo && (
                        <>
                          <div className="mt-2 invoice-text-2">PAYMENT DETAILS</div>
                          <div>
                            <table className="table">
                              <thead>
                                <th className="invoice-text-4" style={{borderBottom:0}}>Account Name</th>
                                <th className="invoice-text-4" style={{borderBottom:0}}>Bank Name</th>
                                <th className="invoice-text-4" style={{borderBottom:0}}>IBAN</th>
                              </thead>
                              <tbody>
                                <td className="invoice-text-1" width={250}>
                                  {
                                    invoiceDetail?.Student?.School?.bankInfo
                                      ?.account_name
                                  }{" "}
                                  {
                                    invoiceDetail?.Student?.School?.address1
                                  }
                                  {" "}
                                  {
                                    invoiceDetail?.Student?.School?.address2
                                  }
                                </td>
                                <td className="invoice-text-1">
                                  {
                                    invoiceDetail?.Student?.School?.bankInfo
                                      ?.bank_name
                                  }
                                </td>
                                <td className="invoice-text-1">
                                  {
                                    invoiceDetail?.Student?.School?.bankInfo
                                      ?.IBAN
                                  }
                                </td>
                              </tbody>
                            </table>
                            <table className="table mt-3">
                              <thead>
                                <th className="invoice-text-4" style={{borderBottom:0}}>Swift Code</th>
                                <th className="invoice-text-4" style={{borderBottom:0}}>Account Number</th>
                              </thead>
                              <tbody>
                                <td className="invoice-text-1">
                                  {
                                    invoiceDetail?.Student?.School?.bankInfo
                                      ?.swift_code
                                  }
                                </td>
                                <td className="invoice-text-1">
                                  {
                                    invoiceDetail?.Student?.School?.bankInfo
                                      ?.account_no
                                  }
                                </td>
                              </tbody>
                            </table>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </>
              ) : (
                <Loader />
              )}
            </Box>
          </div>
        </SwipeableDrawer>
      )}
    </div>
  );
}
